import { render } from "./UserAccountModal.vue?vue&type=template&id=3d8846ff&scoped=true"
import script from "./UserAccountModal.vue?vue&type=script&lang=js"
export * from "./UserAccountModal.vue?vue&type=script&lang=js"

import "./UserAccountModal.vue?vue&type=style&index=0&id=3d8846ff&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d8846ff"]])

export default __exports__